import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { _SSTPeriod } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { InputDate } from "../../../theme/Input/InputDate";


export const SSTPeriod = () => {

    const sstp = useDataBean(_SSTPeriod);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        sstp.instance.getSSTPeriodCatalogPorPropiedades({ State: 100 }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        sstp.setBean({
            State: 100,
            IDEmployee: _single.getAccountID()
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        sstp.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        sstp.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDSSTPeriod', visible: true },
        { title: 'Vigenicia', property: 'Year', visible: true },
        { title: 'Fecha Inicial', property: 'StartDate', visible: true },
        { title: 'Fecha Final', property: 'EndDate', visible: true },
        // { title: 'logueado', property: 'IDEmployee', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${sstp.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Periodo SST">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={sstp.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <YearSelector value={sstp.bean.Year} onChange={(e) => sstp.setBean({ ...sstp.bean, "Year": e })} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="StartDate" label="Fecha Inicial" value={sstp.bean.StartDate} setDate={(e: any) => { sstp.setBean({ ...sstp.bean, "StartDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="EndDate" label="Fecha Final" value={sstp.bean.EndDate} setDate={(e: any) => { sstp.setBean({ ...sstp.bean, "EndDate": e }) }} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {sstp.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}